import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-product-comparison-table-row-header__desc" }
const _hoisted_2 = {
  class: "_line-clamp-1",
  "data-qa": "row-header-props:Name"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")

  return (_openBlock(), _createElementBlock("th", {
    class: _normalizeClass(['gfu-product-comparison-table-row-header', $options.themeClass]),
    "data-qa": "set-item-row-header"
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent($options.getComponent), _mergeProps($options.contextLinkProps, { class: "gfu-product-comparison-table-row-header__link" }), {
      default: _withCtx(() => [
        ($options.isProductPresentationInFullMode)
          ? (_openBlock(), _createBlock(_component_base_image, {
              key: 0,
              src: $props.imageUrl,
              alt: $props.productName,
              width: $options.imageSize,
              height: $options.imageSize
            }, null, 8 /* PROPS */, ["src", "alt", "width", "height"]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString($props.productName), 1 /* TEXT */),
          _createElementVNode("span", {
            class: _normalizeClass($options.descriptionClassList),
            "data-qa": "row-header-props:Price"
          }, _toDisplayString($options.formattedPrice), 3 /* TEXT, CLASS */)
        ])
      ]),
      _: 1 /* STABLE */
    }, 16 /* FULL_PROPS */))
  ], 2 /* CLASS */))
}